
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host([site='GHS']) .location-detail-left__identifiers {
      position:relative;
}

:host([site='GHS']) .location-detail-left__identifiers {
      top:-1rem;
}

:host([site='GHS']) .location-detail-left__identifiers {
      left:-1rem;
}

:host([site='GHS']) .location-detail-left__identifiers {
      display:inline-flex;
}

:host([site='GHS']) .location-detail-left__identifiers {
      align-items:center;
}

:host([site='GHS']) .location-detail-left__identifiers {
      justify-content:center;
}

:host([site='GHS']) .location-detail-left__identifiers {
      border-bottom-right-radius:0.75rem;
}

:host([site='GHS']) .location-detail-left__identifiers {
      border-top-left-radius:0.75rem;
}

:host([site='GHS']) .location-detail-left__identifiers {
      background-color:var(--primary-blue);
}

:host([site='GHS']) .location-detail-left__identifiers {
      padding-left:1rem;
      padding-right:1rem;
}

:host([site='GHS']) .location-detail-left__identifiers {
      padding-top:0.5rem;
      padding-bottom:0.5rem;
}

:host([site='GHS']) .location-detail-left__identifiers {
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
}

:host([site='GHS']) .location-detail-left__identifiers {
      text-transform:uppercase;
}

:host([site='GHS']) .location-detail-left__identifiers {
      line-height:1.5rem;
}

:host([site='GHS']) .location-detail-left__identifiers {
      color:var(--neutral-white);
}

@media (min-width: 1024px) {

      :host([site='GHS']) .location-detail-left__identifiers {
            top:-2rem;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .location-detail-left__identifiers {
            left:-2rem;
      }
}

:host([site='GHS']) .location-detail-left__identifiers .identifier::after {
      margin-left:0.75rem;
}

:host([site='GHS']) .location-detail-left__identifiers .identifier::after {
      margin-right:0.5rem;
}

:host([site='GHS']) .location-detail-left__identifiers .identifier::after {
      opacity:0.5;
}

:host([site='GHS']) .location-detail-left__identifiers .identifier::after{
      content:'|';
    }

:host([site='GHS']) .location-detail-left__identifiers .identifier:last-child::after {
      display:none;
}

:host([site='GHS']) .location-detail-left__identifiers a {
      color:var(--neutral-white);
}

:host([site='GHS']) .location-detail-left__identifiers a {
      text-decoration-line:none;
}

:host([site='GHS']) .location-detail-left__identifiers a:hover {
      text-decoration-line:underline;
}

:host([site='GHS']) .location-detail-left__header {
      margin:0px;
}

:host([site='GHS']) .location-detail-left__header {
      font-family:var(--ff-display);
}

:host([site='GHS']) .location-detail-left__header {
      font-size:var(--fs-3xl);
      line-height:var(--lh-3xl);
}

:host([site='GHS']) .location-detail-left__header {
      color:var(--primary-blue-light-1);
}

:host([site='GHS']) .location-detail-left__header h3 {
      margin-top:0px;
      margin-bottom:0px;
}

:host([site='GHS']) .location-detail-left__header a{
      color:inherit;
      text-decoration:inherit;
    }

:host([site='GHS']) .location-detail-left__header a:hover {
      text-decoration-line:underline;
}

:host([site='GHS']) [cloned-slot-name='location-header'] {
      font-size:var(--fs-3xl);
      line-height:var(--lh-3xl);
}

:host([site='GHS']) [cloned-slot-name='location-header'] {
      font-weight:var(--fw-semibold);
}

:host([site='GHS']) .location-detail-left__address {
      margin-bottom:1.25rem;
}

:host([site='GHS']) .location-detail-left__address {
      font-family:var(--ff-body);
}

:host([site='GHS']) .location-detail-left__address {
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
}

:host([site='GHS']) .location-detail-left__address {
      font-style:normal;
}

:host([site='GHS']) .location-detail-left__address {
      color:var(--neutral-gray-1);
}

:host([site='GHS']) [cloned-slot-name='location-details'] {
      margin-bottom:1.25rem;
}

:host([site='GHS']) [cloned-slot-name='location-details'] {
      display:flex;
}

:host([site='GHS']) [cloned-slot-name='location-details'] {
      flex-direction:column;
}

@media (min-width: 1024px) {

      :host([site='GHS']) [cloned-slot-name='location-details'] {
            flex-direction:row;
      }
}

:host([site='GHS']) .detail {
      border-width:0px;
}

:host([site='GHS']) .detail {
      border-bottom-width:1px;
}

:host([site='GHS']) .detail {
      border-style:solid;
}

:host([site='GHS']) .detail {
      border-color:var(--neutral-gray-4);
}

@media (min-width: 1024px) {

      :host([site='GHS']) .detail {
            border-bottom-width:0px;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .detail {
            border-right-width:1px;
      }
}

:host([site='GHS']) .detail {
      margin-right:0.5rem;
}

:host([site='GHS']) .detail {
      padding-top:0.5rem;
      padding-bottom:0.5rem;
}

:host([site='GHS']) .detail {
      padding-right:0.5rem;
}

@media (min-width: 1024px) {

      :host([site='GHS']) .detail {
            margin-right:1.25rem;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .detail {
            padding-top:1.25rem;
            padding-bottom:1.25rem;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .detail {
            padding-right:1.25rem;
      }
}

:host([site='GHS']) .detail:last-child {
      margin-right:0px;
}

:host([site='GHS']) .detail:last-child {
      border-bottom-width:0px;
}

:host([site='GHS']) .detail:last-child {
      padding-right:0px;
}

@media (min-width: 1024px) {

      :host([site='GHS']) .detail:last-child {
            border-right-width:0px;
      }
}

@media (min-width: 1024px) {

      :host([site='GHS']) .detail:last-child {
            padding-right:0px;
      }
}

:host([site='GHS']) .detail .heading {
      margin:0px;
}

:host([site='GHS']) .detail .heading {
      font-family:var(--ff-display);
}

:host([site='GHS']) .detail .heading {
      font-size:var(--fs-base);
      line-height:var(--lh-base);
}

:host([site='GHS']) .detail .heading {
      color:var(--primary-blue);
}

:host([site='GHS']) .detail .content {
      font-family:var(--ff-body);
}

:host([site='GHS']) .detail .content {
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
}

:host([site='GHS']) .detail .content {
      font-style:normal;
}

:host([site='GHS']) .detail .content {
      color:var(--neutral-gray-1);
}

:host([site='GHS']) .detail .content a {
      color:var(--neutral-gray-1);
}

:host([site='GHS']) .detail .content a {
      text-decoration-line:none;
}

:host([site='GHS']) .detail .content a:hover {
      text-decoration-line:underline;
}

:host([site='GHS']) .detail .content p {
      margin:0px;
}

:host([site='BH']) .location-detail-left__identifiers {
      position:relative;
}

:host([site='BH']) .location-detail-left__identifiers {
      top:-1rem;
}

:host([site='BH']) .location-detail-left__identifiers {
      left:-1rem;
}

:host([site='BH']) .location-detail-left__identifiers {
      display:inline-flex;
}

:host([site='BH']) .location-detail-left__identifiers {
      align-items:center;
}

:host([site='BH']) .location-detail-left__identifiers {
      justify-content:center;
}

:host([site='BH']) .location-detail-left__identifiers {
      border-bottom-right-radius:0.5rem;
}

:host([site='BH']) .location-detail-left__identifiers {
      border-top-left-radius:0.5rem;
}

:host([site='BH']) .location-detail-left__identifiers {
      background-color:var(--primary-blue);
}

:host([site='BH']) .location-detail-left__identifiers {
      padding-left:1rem;
      padding-right:1rem;
}

:host([site='BH']) .location-detail-left__identifiers {
      padding-top:0.5rem;
      padding-bottom:0.5rem;
}

:host([site='BH']) .location-detail-left__identifiers {
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
}

:host([site='BH']) .location-detail-left__identifiers {
      text-transform:uppercase;
}

:host([site='BH']) .location-detail-left__identifiers {
      line-height:1.5rem;
}

:host([site='BH']) .location-detail-left__identifiers {
      color:var(--neutral-white);
}

@media (min-width: 1024px) {

      :host([site='BH']) .location-detail-left__identifiers {
            top:-2rem;
      }
}

@media (min-width: 1024px) {

      :host([site='BH']) .location-detail-left__identifiers {
            left:-2rem;
      }
}

:host([site='BH']) .location-detail-left__identifiers .identifier::after {
      margin-left:0.75rem;
}

:host([site='BH']) .location-detail-left__identifiers .identifier::after {
      margin-right:0.5rem;
}

:host([site='BH']) .location-detail-left__identifiers .identifier::after {
      opacity:0.5;
}

:host([site='BH']) .location-detail-left__identifiers .identifier::after{
      content:'|';
    }

:host([site='BH']) .location-detail-left__identifiers .identifier:last-child::after {
      display:none;
}

:host([site='BH']) .location-detail-left__identifiers a {
      color:var(--neutral-white);
}

:host([site='BH']) .location-detail-left__identifiers a {
      text-decoration-line:none;
}

:host([site='BH']) .location-detail-left__identifiers a:hover {
      text-decoration-line:underline;
}

:host([site='BH']) .location-detail-left__header {
      margin:0px;
}

:host([site='BH']) .location-detail-left__header {
      margin-bottom:0.5rem;
}

:host([site='BH']) .location-detail-left__header {
      font-family:var(--bh-ff-body);
}

:host([site='BH']) .location-detail-left__header {
      font-size:var(--bh-fs-heading-05);
      line-height:var(--bh-lh-heading-05);
      letter-spacing:var(--bh-ls-heading-05);
}

:host([site='BH']) .location-detail-left__header h3 {
      margin-top:0px;
      margin-bottom:0px;
}

:host([site='BH']) .location-detail-left__header h3 {
      font-weight:var(--fw-light);
}

:host([site='BH']) .location-detail-left__header a{
      color:inherit;
      text-decoration:inherit;
    }

:host([site='BH']) .location-detail-left__header a:hover {
      text-decoration-line:underline;
}

:host([site='BH']) [cloned-slot-name='location-header'] {
      font-size:var(--fs-3xl);
      line-height:var(--lh-3xl);
}

:host([site='BH']) [cloned-slot-name='location-header'] {
      font-weight:var(--fw-semibold);
}

:host([site='BH']) .location-detail-left__address {
      margin-bottom:1.25rem;
}

:host([site='BH']) .location-detail-left__address {
      font-family:var(--ff-body);
}

:host([site='BH']) .location-detail-left__address {
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
}

:host([site='BH']) .location-detail-left__address {
      font-style:normal;
}

:host([site='BH']) .location-detail-left__address {
      color:var(--neutral-gray-1);
}

:host([site='BH']) [cloned-slot-name='location-details'] {
      margin-bottom:1.25rem;
}

:host([site='BH']) [cloned-slot-name='location-details'] {
      display:flex;
}

:host([site='BH']) [cloned-slot-name='location-details'] {
      flex-direction:column;
}

@media (min-width: 1024px) {

      :host([site='BH']) [cloned-slot-name='location-details'] {
            flex-direction:row;
      }
}

:host([site='BH']) .detail {
      border-width:0px;
}

:host([site='BH']) .detail {
      border-bottom-width:1px;
}

:host([site='BH']) .detail {
      border-style:solid;
}

:host([site='BH']) .detail {
      border-color:var(--neutral-gray-4);
}

@media (min-width: 1024px) {

      :host([site='BH']) .detail {
            border-bottom-width:0px;
      }
}

@media (min-width: 1024px) {

      :host([site='BH']) .detail {
            border-right-width:1px;
      }
}

:host([site='BH']) .detail {
      margin-right:0.5rem;
}

:host([site='BH']) .detail {
      padding-top:0.5rem;
      padding-bottom:0.5rem;
}

:host([site='BH']) .detail {
      padding-right:0.5rem;
}

@media (min-width: 1024px) {

      :host([site='BH']) .detail {
            margin-right:1.25rem;
      }
}

@media (min-width: 1024px) {

      :host([site='BH']) .detail {
            padding-top:0px;
            padding-bottom:0px;
      }
}

@media (min-width: 1024px) {

      :host([site='BH']) .detail {
            padding-right:1.25rem;
      }
}

:host([site='BH']) .detail:last-child {
      margin-right:0px;
}

:host([site='BH']) .detail:last-child {
      border-bottom-width:0px;
}

:host([site='BH']) .detail:last-child {
      padding-right:0px;
}

@media (min-width: 1024px) {

      :host([site='BH']) .detail:last-child {
            border-right-width:0px;
      }
}

@media (min-width: 1024px) {

      :host([site='BH']) .detail:last-child {
            padding-right:0px;
      }
}

:host([site='BH']) .detail .heading {
      margin:0px;
}

:host([site='BH']) .detail .heading {
      padding-bottom:0.5rem;
}

:host([site='BH']) .detail .heading {
      padding-top:1rem;
}

:host([site='BH']) .detail .heading {
      font-family:var(--bh-ff-body);
}

:host([site='BH']) .detail .heading {
      font-size:var(--bh-fs-heading-03);
      line-height:var(--bh-lh-heading-03);
      letter-spacing:var(--bh-ls-heading-03);
}

:host([site='BH']) .detail .heading {
      color:var(--bh-neutral-black);
}

:host([site='BH']) .detail .content {
      margin:0px;
}

:host([site='BH']) .detail .content {
      padding-bottom:1rem;
}

:host([site='BH']) .detail .content {
      font-family:var(--bh-ff-body);
}

:host([site='BH']) .detail .content {
      font-size:var(--bh-fs-body-02);
      line-height:var(--bh-lh-body-02);
      letter-spacing:var(--bh-ls-body-02);
}

:host([site='BH']) .detail .content {
      font-style:normal;
}

:host([site='BH']) .detail .content {
      color:var(--bh-neutral-darker);
}

@media (min-width: 1024px) {

      :host([site='BH']) .detail .content {
            padding-top:0px;
            padding-bottom:0px;
      }
}

:host([site='BH']) .detail .content a {
      color:var(--bh-brand-primary-default);
}

:host([site='BH']) .detail .content a {
      text-decoration-line:underline;
}

:host([site='BH']) .detail .content a:hover {
      text-decoration-line:none;
}

:host([site='BH']) .detail .content p {
      margin:0px;
}

:host([site='BH']) .detail .content p {
      padding-bottom:0.25rem;
}
`;